<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<!-- AppConfig -->
			<div class="card">
				<div class="card-header">
					dbconfig : <em>{{dbconfig?.dataSource?.url}}</em>
				</div>
				<div class="card-body p-4 p-md-5">
					<b-form ref="instanceForm" id="instanceForm" autocomplete="off" >
						<!-- Flash -->
						<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />
						<div class="form-row">

							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.appCode')}}
									</label>
									<input type="text" v-model="instance.appCode" class="form-control" :class="{'is-invalid': v$.instance?.appCode.$error, 'is-valid': (!v$.instance?.appCode.$error && v$.instance?.appCode.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.appCode.$error">
										{{ v$.instance.appCode.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<div class="col-md-8">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.appName')}}
									</label>
									<input type="text" v-model="instance.appName" class="form-control" :class="{'is-invalid': v$.instance.appName.$error, 'is-valid': (!v$.instance.appName.$error && v$.instance.appName.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.appName.$error">
										{{ v$.instance.appName.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<div class="col-md-12">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.sideNavInfoTop')}}
									</label>
									<input type="text" v-model="instance.sideNavInfoTop" class="form-control" :class="{'is-invalid': v$.instance.sideNavInfoTop.$error, 'is-valid': (!v$.instance.sideNavInfoTop.$error && v$.instance.sideNavInfoTop.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.sideNavInfoTop.$error">
										{{ v$.instance.sideNavInfoTop.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<div class="col-md-12">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.sideNavInfoBot')}}
									</label>
									<input type="text" v-model="instance.sideNavInfoBot" class="form-control" :class="{'is-invalid': v$.instance.sideNavInfoBot.$error, 'is-valid': (!v$.instance.sideNavInfoBot.$error && v$.instance.sideNavInfoBot.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.sideNavInfoBot.$error">
										{{ v$.instance.sideNavInfoBot.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<!-- STYLE-COLOR -->
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.layoutBC1')}}
									</label>
									<input type="text" v-model="instance.layoutBC1" class="form-control" :class="{'is-invalid': v$.instance.layoutBC1.$error, 'is-valid': (!v$.instance.layoutBC1.$error && v$.instance.layoutBC1.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.layoutBC1.$error">
										{{ v$.instance.layoutBC1.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.layoutBC2')}}
									</label>
									<input type="text" v-model="instance.layoutBC2" class="form-control" :class="{'is-invalid': v$.instance.layoutBC2.$error, 'is-valid': (!v$.instance.layoutBC2.$error && v$.instance.layoutBC2.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.layoutBC2.$error">
										{{ v$.instance.layoutBC2.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.modalTitleHC')}}
									</label>
									<input type="text" v-model="instance.modalTitleHC" class="form-control" :class="{'is-invalid': v$.instance.modalTitleHC.$error, 'is-valid': (!v$.instance.modalTitleHC.$error && v$.instance.modalTitleHC.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.modalTitleHC.$error">
										{{ v$.instance.modalTitleHC.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>

							<!-- FORMAT DATE -->
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.dateLongFormat')}}
									</label>
									<input type="text" v-model="instance.dateLongFormat" class="form-control" :class="{'is-invalid': v$.instance.dateLongFormat.$error, 'is-valid': (!v$.instance.dateLongFormat.$error && v$.instance.dateLongFormat.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.dateLongFormat.$error">
										{{ v$.instance.dateLongFormat.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.dateShortFormat')}}
									</label>
									<input type="text" v-model="instance.dateShortFormat" class="form-control" :class="{'is-invalid': v$.instance.dateShortFormat.$error, 'is-valid': (!v$.instance.dateShortFormat.$error && v$.instance.dateShortFormat.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.dateShortFormat.$error">
										{{ v$.instance.dateShortFormat.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<!-- CHARTS -->
							<div class="col-md-9">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.chartList')}}
									</label>
									<input type="text" v-model="instance.chartList" class="form-control" :class="{'is-invalid': v$.instance.chartList.$error, 'is-valid': (!v$.instance.chartList.$error && v$.instance.chartList.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.chartList.$error">
										{{ v$.instance.chartList.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>
							<div class="col-md-3">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.defaultChart')}}
									</label>
									<input type="text" v-model="instance.defaultChart" class="form-control" :class="{'is-invalid': v$.instance.defaultChart.$error, 'is-valid': (!v$.instance.defaultChart.$error && v$.instance.defaultChart.$dirty) }" :disabled="typeView=='show'"/>
									<span class="small text-muted d-none d-md-block" v-if="v$.instance.defaultChart.$error">
										{{ v$.instance.defaultChart.$errors[0].$message }}
									</span>
								</b-form-group>				
							</div>


							<!-- REPMODEL -->
							<div class="col-md-12">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.imgLogoHq')}}
									</label>
									<div class="input-group">
										<input v-show="['new', 'edit'].includes(typeView)" ref="fileHq" type="file" @change="handleFileUpload($event, 'imgLogoHq')" class="input-group-text form-control"/>

										<input type="text" v-model="instance.imgLogoHq" class="form-control" aria-describedby="basic-addon3" :disabled="typeView=='show'" />
									</div>
								</b-form-group>
							</div>
							<div class="col-md-12">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.imgLogoLq')}}
									</label>
									<div class="input-group">
										<input v-show="['new', 'edit'].includes(typeView)" ref="fileLq" type="file" @change="handleFileUpload($event, 'imgLogoLq')" class="input-group-text form-control"/>

										<input type="text" v-model="instance.imgLogoLq" class="form-control" aria-describedby="basic-addon3" :disabled="typeView=='show'" />
									</div>
								</b-form-group>
							</div>
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.repInfosSupL1')}}
									</label>
									<input type="text" v-model="instance.repInfosSupL1" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.repInfosSupL2')}}
									</label>
									<input type="text" v-model="instance.repInfosSupL2" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.repInfosSupR1')}}
									</label>
									<input type="text" v-model="instance.repInfosSupR1" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.repInfosSupR2')}}
									</label>
									<input type="text" v-model="instance.repInfosSupR2" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.repInfosSep')}}
									</label>
									<input type="text" v-model="instance.repInfosSep" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.repInfosFoot')}}
									</label>
									<input type="text" v-model="instance.repInfosFoot" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<!-- FOOTER -->
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.emailFrom')}}
									</label>
									<input type="text" v-model="instance.emailFrom" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<div class="col-md-6">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.emailTitlePrefix')}}
									</label>
									<input type="text" v-model="instance.emailTitlePrefix" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.emailSignature')}}
									</label>
									<input type="email" v-model="instance.emailSignature" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.emailFooterText')}}
									</label>
									<input type="text" v-model="instance.emailFooterText" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>
							<div class="col-md-4">
								<b-form-group class="small mb-1">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.websiteUrl')}}
									</label>
									<input type="url" v-model="instance.websiteUrl" class="form-control" :disabled="typeView=='show'" />
								</b-form-group>
							</div>

						</div>
						<!-- <div>
							<span>Aucune configuration</span>
						</div> -->
					</b-form>
				</div>

				<div align="center" class="card-footer" v-if="$store.getters.isAuthorized(['ROLE_ADMIN', 'ROLE_MANAGER'])">
					<b-button v-if="typeView != 'show'" class="btn btn-success" @click="handleSubmit()" >
						<span v-if="typeView == 'new'">
							<fa icon="check"/>
							{{ $t("default.button.create")}}
						</span>
						<span v-if="typeView == 'edit'">
							<fa icon="check"/>
							{{ $t("default.button.update")}}
						</span>
					</b-button>
					&ensp;
					<b-button v-if="typeView == 'edit' || typeView == 'new' " class="btn btn-dark" @click="typeView = 'show'" >
						<span>
							<fa icon="times"/>
							{{ $t("default.button.cancel")}}
						</span>
					</b-button>
					
					<b-button v-if="typeView == 'show' && instance?.id " class="btn btn-primary" 
						@click="typeView = 'edit'" >
						<span>
							<fa icon="edit"/>
							{{ $t("default.button.edit")}}
						</span>
					</b-button>
					<b-button v-if="typeView == 'show' && !instance?.id" class="btn btn-primary" @click="typeView = 'new'" >
						<span>
							<fa icon="add"/>
							{{ $t("default.button.add")}}
						</span>
					</b-button>
					
				</div>


			</div>
		</div>

	</div>
</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import { useVuelidate } from '@vuelidate/core'
	import { required, email,minLength, maxLength } from '@vuelidate/validators'

	export default {
		name: 'appConfig',
		/*props: {
			itemId: {
				type: Number,
				default: NaN,
				required: false
			}
		},*/
		
		setup () { return { v$: useVuelidate() }},
		components: {
			'header-layout': Header
		},

		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('appconfig.label'),
				pageTitle: this.$t('appconfig.list'),
				pageIcon: 'users',
				instanceClassAttr: {
					instanceClass: 'appconfig'
				},
				instance: {
					// INFO-SIDENAV
					sideNavInfoTop: '<h6>ALTI SOLUTIONS</h6><h2>ALTIS</h2>',
					sideNavInfoBot: '<h6>Bamako - MALI</h6><h4>altis.com</h4>',

					// STYLE-COLOR
					layoutBC1: '#ecaf52',
					layoutBC2: '#b94646',
					modalTitleHC: '#363d47',

					// FORMAT DATE
					dateLongFormat: 'DD/MM/YYYY HH:mm:ss',
					dateShortFormat: 'DD/MM/YYYY',

					// CHARTS
					chartList: 'PieChart,ColumnChart,BarChart,LineChart,ScatterChart,AreaChart,Histogram,Table',
					defaultChart: 'ColumnChart'
				},
				vueRules: {},
				typeView: 'show',
				dbconfig:{}
			
			}
		},
		validations () {
			return this.vueRules
		},
		created (){
			this.vueRules = this.createVeerules()
		},
		async mounted () {
			this.pageTitle = this.$t('appconfig.'+this.typeView)
			this.$store.dispatch('initFlash');

			// GET dbconfig
			await this.$store.dispatch('axiosGet', {
				url: '/api/index'
			})
			.then(response => {
				if(response && response.data && response.data.db)
					this.dbconfig = response.data.db
			})
			.catch(error => {
				console.log('error catch dbconfig == ', error.message)
			})

			// GET Unique appconfig
			await this.$store.dispatch('axiosGet', {
				domain: 'appconfig'
			})
			.then(response => {
				if(response && response.data && response.data[0])
					this.instance = response.data[0]
			})
			.catch(error => {
				console.log('error catch appconfigList == ', error.message)
			})
		},
		methods: {
			createVeerules(){
				let rules = {
					instance: {
						appCode: { required },
						appName: { required },
						
						sideNavInfoTop: { required },
						sideNavInfoBot: { required },
						
						layoutBC1: { required },
						layoutBC2: { required },
						modalTitleHC: { required },
						dateLongFormat: { required },
						dateShortFormat: { required },
						chartList: { required },
						defaultChart: { required }
						
					}
				}
				return rules
			},
			handleFileUpload(e, fileName) {
				try {
					const file = e.target.files[0];
					const reader = new FileReader();
					reader.onloadend = () => {
						// reader.result contains the data URL: "data:image/png;base64,iVBORw..."
						const base64String = reader.result.split(',')[1];
						if(fileName == 'imgLogoHq')
							this.instance.imgLogoHq = base64String;
						if(fileName == 'imgLogoLq')
							this.instance.imgLogoLq = base64String;
					};
					reader.readAsDataURL(file);
				} 
				catch (error) {
					console.error("Error converting file:", error);
				}

			},
			async handleSubmit() {

				// this.instance.minAmount = this.minAmount
				
				const result = await this.v$.$validate()
				if (!result)
					return
				else{
					this.$store.dispatch('initFlash');
					this.$store.dispatch('loading')
					this.axiosPost()
				}
			},

			async axiosPost() {
				try {

					if(this.instance.id){
						await this.$store.dispatch('axiosPut', {
							domain: 'appconfig',
							data: this.instance,
							id:this.instance.id
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("appconfig.label") + " "+this.instance.id;
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.$router.push('/appconfig')
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.updated.message', { obj: msg})
									});
									this.$router.go(0)
								}
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error axiosPut === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					else {
						await this.$store.dispatch('axiosPost', {
							domain: 'appconfig',
							data: this.instance
						})
						.then(res => {
							this.$nextTick(() => {
								let msg = this.$t("appconfig.label") + " "+res.data.id;
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.$router.push('/appconfig')
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.created.message', { obj: msg})
									});
									this.$router.go(0)
								}
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error axiosPost === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
				
				}
				catch (e) {
					console.log('Error ', e)
				}

			},



		}




	}



</script>



